import MirrorActivityLayout from "../components/MirrorActivityLayout";
import mirrorProjectorConsole from "../assets/images/icons/mirror-projector-console-2.svg";
import { useTranslation } from "../components/Localization";

export default function MirrorConsoleTaskPage() {
  const { t } = useTranslation();
  return (
    <MirrorActivityLayout
      taskKey="console"
      step={3}
      progressIcon="bottom"
      backTo="/tukorterem/video-jobb"
      nextTo="/tukorterem/festmeny"
    >
      <img
        className="mirror-console-graphic"
        src={mirrorProjectorConsole}
        alt={t("accessibility.projectorConsole")}
      />
    </MirrorActivityLayout>
  );
}
